/**
 * 运维平台专用存储工具
 * 使用独立的存储 key，与用户界面完全隔离
 */
const OPS_USER_STORAGE_KEY = 'ops_auth_user';
const OPS_DATA_STORAGE_KEY = 'ops_platform_data';

export const opsStorageUtil = {
  // ========== 用户信息（使用独立的 key） ==========
  saveUser(user) {
    try {
      sessionStorage.setItem(OPS_USER_STORAGE_KEY, JSON.stringify(user));
      return true;
    } catch (error) {
      console.error('[OpsStorage] 保存用户失败:', error);
      return false;
    }
  },

  getUser() {
    try {
      const dataStr = sessionStorage.getItem(OPS_USER_STORAGE_KEY);
      if (!dataStr) return null;
      
      const user = JSON.parse(dataStr);
      
      // 验证用户数据完整性
      if (!user || typeof user !== 'object') {
        console.warn('[OpsStorage] 用户数据格式无效，清除存储');
        try {
          this.clearUser();
        } catch (clearError) {
          console.error('[OpsStorage] 清除无效用户数据失败:', clearError);
        }
        return null;
      }
      
      // 验证必要字段
      if (!user.id || !user.role) {
        console.warn('[OpsStorage] 用户数据不完整，清除存储', user);
        try {
          this.clearUser();
        } catch (clearError) {
          console.error('[OpsStorage] 清除不完整用户数据失败:', clearError);
        }
        return null;
      }
      
      // 验证是否为运维管理员
      if (user.role !== 'op') {
        console.warn('[OpsStorage] 用户角色不是op，清除存储', user.role);
        try {
          this.clearUser();
        } catch (clearError) {
          console.error('[OpsStorage] 清除非op用户数据失败:', clearError);
        }
        return null;
      }
      
      return user;
    } catch (error) {
      console.error('[OpsStorage] 读取用户失败:', error);
      // 如果解析失败，清除无效数据
      try {
        sessionStorage.removeItem(OPS_USER_STORAGE_KEY);
      } catch (clearError) {
        console.error('[OpsStorage] 清除无效用户数据失败:', clearError);
      }
      return null;
    }
  },

  clearUser() {
    try {
      sessionStorage.removeItem(OPS_USER_STORAGE_KEY);
      return true;
    } catch (error) {
      console.error('[OpsStorage] 清除用户失败:', error);
      return false;
    }
  },

  // ========== 运维平台数据（独立存储） ==========
  saveOpsData(data, userId) {
    try {
      if (!userId) {
        console.warn('[OpsStorage] 未提供用户ID，无法保存数据');
        return false;
      }
      const storageKey = `${OPS_DATA_STORAGE_KEY}_${userId}`;
      const dataToSave = {
        ...data,
        timestamp: Date.now(),
        userId: userId
      };
      sessionStorage.setItem(storageKey, JSON.stringify(dataToSave));
      return true;
    } catch (error) {
      console.error('[OpsStorage] 保存运维数据失败:', error);
      return false;
    }
  },

  getOpsData(userId) {
    try {
      if (!userId) return null;
      const storageKey = `${OPS_DATA_STORAGE_KEY}_${userId}`;
      const dataStr = sessionStorage.getItem(storageKey);
      if (!dataStr) return null;
      
      const data = JSON.parse(dataStr);
      // 验证用户ID是否匹配
      if (data.userId !== userId) {
        console.warn('[OpsStorage] 用户ID不匹配，清除该数据');
        this.clearOpsData(userId);
        return null;
      }
      return data;
    } catch (error) {
      console.error('[OpsStorage] 读取运维数据失败:', error);
      return null;
    }
  },

  clearOpsData(userId) {
    try {
      if (!userId) return false;
      const storageKey = `${OPS_DATA_STORAGE_KEY}_${userId}`;
      sessionStorage.removeItem(storageKey);
      return true;
    } catch (error) {
      console.error('[OpsStorage] 清除运维数据失败:', error);
      return false;
    }
  },

  // 清除所有运维平台数据
  clearAllOpsData() {
    try {
      const keys = Object.keys(sessionStorage);
      keys.forEach(key => {
        if (key.startsWith(OPS_DATA_STORAGE_KEY)) {
          sessionStorage.removeItem(key);
        }
      });
      return true;
    } catch (error) {
      console.error('[OpsStorage] 清除所有运维数据失败:', error);
      return false;
    }
  }
};

